import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/core/services/base.service';
import { BaseResponse } from 'src/app/core/models/responses/base-response';
import { PosTerminal } from '../models/pos/pos-terminal';
import { PosTerminalFilter } from '../models/pos/pos-terminal-filter';

@Injectable({
  providedIn: 'root'
})
export class PosTerminalService extends BaseService<PosTerminal, PosTerminalFilter, number> {

  apiUrl = environment.urlAddress + '/PosTerminal'

  constructor(private http: HttpClient) {
    super(http, environment.urlAddress + '/PosTerminal')
  }

  /** Kasanin POS ayarini getirir; ayar yoksa istek 404 doner. */
  getByCaseId(caseId: number): Observable<BaseResponse<PosTerminal>> {
    return this.http.get<BaseResponse<PosTerminal>>(this.apiUrl + '/by-case/' + caseId)
  }
}
